import styled from "styled-components";
import { processingStatus } from "../store/common/models";
import { colours } from "../styles/colours";

export const ProcessingStatus = styled.span.attrs<
  {
    processingStatus: typeof processingStatus.T;
  },
  {
    processingStatus: typeof processingStatus.T; // TODO fix this, it's an issue with the library
    status: typeof processingStatus.T;
  } & React.HTMLAttributes<HTMLSpanElement>
>((props) => ({
  children: props.processingStatus,
  status: props.processingStatus,
  processingStatus: props.processingStatus,
}))`
  color: ${({ status }) => {
    switch (status) {
      case "PENDING":
        return colours.darkGrey;
      case "COMPLETED":
        return colours.green;
      default:
        return colours.red;
    }
  }};
`;
